import React, { forwardRef, useState, useEffect } from "react";
import {
  Button,
  Grid,
  Paper,
  Typography,
  Box,
  Tab,
  Tabs,
  Snackbar,
  Slide,
  LinearProgress,
  Divider,
  withStyles,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router";
import MaterialTable from "material-table";
import useStyles from "../../hooks/useStyles";
import { Strings } from "../../assets/res/en";
import useCardholdersDetails from "../../hooks/modules/cardholder/useCardholdersDetails";
import cardholderDataColumn from "../../dataColumns/cardholderDataColumn";
import useZendesk from "../../hooks/modules/cardholder/useZendesk";
import { ModalDialog, TabPanel } from "../../components/tools";
import { SearchBar } from "../../components/searchBox/SearchBar";
import Unauthorized from "../../components/Unauthorized";
import Carousel from "react-material-ui-carousel";
import { GoogleMap, LoadScript, Marker, useJsApiLoader  } from '@react-google-maps/api';
import GoogleMapContainer from "../../components/GoogleMapContainer";
import LoadingContainer from "../../components/LoadingContainer";
import DummyCard from "../../components/DummyCard";
import cx from 'classnames'
import TransactionTable from "../reports/components/TransactionListCard.jsx/TransactionTable";
import TransactionTableWrapper from "./TransactionsTableWrapper";
import KycButton from "../../components/Platform/KycButton/KycButton";

function CardholderDetails(props) {
  const history = useHistory();
  const classes = useStyles();
  const { transStylingOption } = cardholderDataColumn(classes);
  const {
    details,
    isLoading,
    detailsLoading, 
    balanceLoading,
    generalLoading,
    cardBasicDetails,
    openDialog,
    handleModalClose,
    modalHeader,
    modalContent,
    modalFormResetKeys,
    handleActionClick,
    cardTabDetails,
    value,
    setValue,
    TranscationTabIndex,
    setTranscationTabIndex,
    prevTransactions,
    cardHolderPermission,
    statusAPIres,
    snak_open,
    setSnackOpen,
    allCardData,
    onRealChange,
    realDetails,
    cardRealIndex,
    config,
    device_log,
    cardInfo
  } = useCardholdersDetails();

  const [mapsHidden, setMapsHidden] = useState(false)
  const [enableCardButtons, setEnableCardButtons] = useState(false)

  const ZendeskItems = useZendesk("https://abhraint.zendesk.com");


  useEffect(() => {
    if(cardInfo){
      const {agreementAccepted, status} = cardInfo
      const _enableCardButtons = agreementAccepted
      setEnableCardButtons(_enableCardButtons)
    }
  },[cardInfo ])

  

  return (
    <>
      {cardHolderPermission.read === true ? (
        <>
          <Grid container spacing={3}>
              <Grid item>
                <Button
                  onClick={() => history.goBack()}
                  startIcon={<ChevronLeft />}
                  variant="text"
                  color="primary"
                >
                  {Strings.BACK_TO_CARDHOLDERS}
                </Button>
              </Grid>
              <Grid item xs>
                <Grid container spacing={2}>
                  {realDetails.map((item, i) => (
                    <Grid item key={`cr_${i}`}>
                      <Box 
                        borderRadius={5} minHeight={20}
                        p={1} mb={1.25}
                        className={item.classDetail}>
                          <LightTooltip title={item.title}>
                            <Typography variant="subtitle2" align="center">
                              {item.value}
                            </Typography>
                          </LightTooltip>
                        
                      </Box>
                    </Grid>
                    ))}
                </Grid>
              </Grid>
          </Grid>
          

          <Paper elevation={4} className={classes.chPaper}>
            <Grid container direction="row" justify="center" spacing={3}>
              <Grid item sm={6} style={{ width: "100%" }}>
                <Paper variant="outlined" className={classes.chPaperInner} style={{position:'relative'}}>
                  <div >
                    <LoadingContainer loading={generalLoading || detailsLoading}/>
                    <>
                        <div>
                          <Grid container>
                            <Grid item xs>
                              <Typography variant="h1" className={classes.chPaperH1_400}>
                                {details.fullname}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <KycButton />
                            </Grid>
                          </Grid>
                        </div>
                        
                        <Box marginBottom={2}></Box>
                        {cardBasicDetails.map((item) => (
                          <Box marginBottom={1.25} key={`cbd_${item.title}`}>
                            <div>
                              
                                <Grid container>
                                  <Grid item xs={12}>
                                    <Typography component="span">{item.title}</Typography>
                                  </Grid>
                                  <Typography
                                    variant="subtitle2"
                                    className={classes.chValue}
                                  >
                                    {item.value}
                                  </Typography>
                                </Grid>
                              
                              
                            </div>
                            
                          </Box>
                        ))}
                      </>
                  </div>

                  
                </Paper>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleActionClick}
                  className={classes.chCTA}
                >
                  {Strings.MORE}
                </Button>
              </Grid>
              <Grid item sm={6} style={{ width: "100%" }}>
                <Paper variant="outlined" className={classes.chPaperInner} style={{position:'relative'}}>
               
                  <LoadingContainer loading={generalLoading || balanceLoading}/>
                    <>
                      <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs"
                      >
                        {cardTabDetails.map((item) => {
                          return <Tab
                            key={item.tab_title}
                            label={item.title}
                            component={forwardRef((props, ref) => (
                              <>
                                <Button
                                  {...props}
                                  ref={ref}
                                  fullWidth
                                  onClick={() => setValue(item.index)}
                                  className={classes.cardAmtPosLeft}
                                >
                                  <Grid container spacing={1} direction="row">
                                    {props.children}
                                    <Grid item>
                                      <div style={{marginRight:8}}>
                                        <img
                                          src={item.cardImage}
                                          alt=""
                                          className={classes.logoImg}
                                        />
                                      </div>
                                    </Grid>
                                    <Grid item className={classes.no_padding}>
                                      <Grid container direction="column" justify="space-evenly">
                                        <Grid item>
                                          <Typography
                                            variant="caption"
                                            className={classes.chDated}
                                          >
                                            {item.tab_title}
                                          </Typography>
                                        </Grid>
                                        <Grid item>
                                          <Typography
                                            variant="body1"
                                            className={classes.chAmount}
                                          >
                                            {item.balance ? item.balance : "$0.00"}{" "}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Button>
                              </>
                            ))}
                          />
                        })}
                      </Tabs>
                      {cardTabDetails.map((item) => {

                        return <TabPanel
                          key={`ctd_${item.index}`}
                          value={value}
                          index={item.index}
                          type={item.type}
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Grid container direction="row" justify="center">
                                {
                                  item.backgroundImage ?
                                  <div >
                                    <img
                                      className={classes.chCardImg}
                                      src={`${item.backgroundImage}`}
                                      alt="Loading.." />
                                  </div> : (
                                    <DummyCard />
                                  )
                                }
                                
                              </Grid>
                            </Grid>
                            {enableCardButtons ? <Grid item xs={12}>
                              <Divider /> 
                            </Grid> : null}
                            {enableCardButtons ?
                            <Grid item xs={12} className={classes.chCTAContainer}>
                              <Grid container direction="row" justify="center" spacing={2}>
                                {item.actions.map((actionItem) => (
                                  <Grid key={actionItem.title} item xs={12} sm={6} lg={3}>
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      className={`${classes.themedButton} ${classes.chBtn}`}
                                      fullWidth
                                      disableElevation
                                      onClick={(e) => actionItem.action(item.type)}
                                    >
                                      {actionItem.title}
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>
                            </Grid>
                            : null}
                          </Grid>
                        </TabPanel>
                      })}
                  </>
                </Paper>
              </Grid>
            </Grid>
          </Paper>

          <div className={classes.chPaperTranNoPadding}>
            <div className={classes.cardholder_transaction_container}>
              <div className={cx({
                [classes.cardholer_google_map]:true,
                [classes.cardholer_google_map_hidden]:mapsHidden,
              })}>
                <GoogleMapContainer data={device_log} loading={generalLoading || detailsLoading} mapsHidden={mapsHidden} onChangeVisible={(val) => setMapsHidden(val)}/>

              </div>
              <div className={cx({
                [classes.crh_transaction_d]:true,
                [classes.crh_transaction_d_expandable]:mapsHidden,
              })}> 
                    <div className={classes.chPaperTranInner_t0}>
                  <Typography variant="h1" className={classes.chPaperH1_TranHead}>
                    {Strings.PREVIOUSTRANSACTIONS}
                  </Typography>
                </div>
                <Paper elevation={4} className={classes.chPaperInner}>
                  <TransactionTableWrapper />
                  {/*<Tabs
                    value={TranscationTabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs"
                  >
                    {prevTransactions.map((item) => (
                      <Tab
                        key={`pt_${item.tab_title}`}
                        label={item.title}
                        component={forwardRef((props, ref) => (
                          <>
                            <Button
                              {...props}
                              ref={ref}
                              fullWidth
                              onClick={() => setTranscationTabIndex(item.index)}
                              className={classes.cardAmtPosLeft}
                            >
                              <Typography variant="body2"  className={classes.chCardName}                                      >
                                {item.cardName}
                              </Typography>
                            </Button>
                          </>
                        ))}
                      />
                    ))}
                        </Tabs>
                  {prevTransactions.map((item) => (
                    <TabPanel
                      key={`ptd_${item.index}`}
                      value={TranscationTabIndex}
                      index={item.index}
                      type={item.type}
                    >
                      <Grid container>
                        <Grid item xs={12} className={classes.marginTop2}>
                          <SearchBar
                            options={item.searchOption}
                            barType="default"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          
                          <MaterialTable
                            columns={item.columns}
                            tableRef={item.tableRef}
                            data={(query) => item.getData(query, item.type)}
                            isLoading={isLoading}
                            detailPanel={item.detailPanel}
                            options={transStylingOption}
                            components={{
                              Container: props => <Paper {...props} variant="outlined" />
                            }}
                          />
                        </Grid>
                      </Grid>
                    </TabPanel>
                  ))}*/}
                </Paper>
              </div>
            </div>
          </div>

          <Paper elevation={4} className={classes.chPaperTran}>
            <Grid container direction="row" spacing={3}>
              <Grid item md={12}>
                <Typography variant="h1" className={classes.chPaperH1_TranHead}>
                  {Strings.ZENDESK}
                </Typography>
              </Grid>
              <Grid item md={4}>
                {ZendeskItems}
              </Grid>
            </Grid>
          </Paper>

          <ModalDialog
            open={openDialog}
            handleClose={handleModalClose}
            modalHeader={modalHeader}
            modalContent={modalContent}
            modalFormResetKeys={modalFormResetKeys}
          />
          {
            <Snackbar
              open={snak_open}
              autoHideDuration={6000}
              onClose={() => setSnackOpen(false)}
              TransitionComponent={(props) => (
                <Slide {...props} direction="right" />
              )}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                severity={statusAPIres.success === true ? "success" : "error"}
                variant="filled"
              >
                {statusAPIres.message}
              </Alert>
            </Snackbar>
          }
        </>
      ) : cardHolderPermission.read === false ? (
        <Unauthorized />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}

const innerUserStyles = makeStyles(theme => ({
  transaction_container:{
    background:'red'
  }
}))


export default CardholderDetails;



const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#3f51b5",
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);
